<template>
<div id="pt401" class="pt401" v-cloak>
    <breadcrumb :decriptPage="$t('common.labels.memberRegistration')"></breadcrumb>
    <div>
        <div class="itemTitle">
            <h2>{{$t('pt401.labels.title2')}}</h2>
        </div>
        <div class="section-inner">
            <h3 class="sectionTitle">{{$t('pt401.labels.title')}}</h3>
            <p class="memberCompInfo">{{$t('pt401.labels.dicription')}}<br>{{$t('pt401.labels.dicription2')}}</p>
            <div v-html="descriptionInfo['1']"/>
            <div class="memberCompBtn">
                <a v-if="syoninFlg == 0" class="btnSubmit" name="to_mypagetop" @click="buy_step2()" :title="$t('common.labels.myPgage')">{{$t('pt401.labels.toMyPageTop')}}</a>
                <a v-else class="btnSubmit" name="to_pagetop" @click="buy_step3()" :title="$t('common.labels.homePage')">{{$t('pt401.labels.toPageTop')}}</a>
            </div>
            <div v-if="fromCart == '1'" class="memberCompBtn"><a class="btnSubmit" @click="buy_step1()" >{{$t('pt401.labels.value')}}</a></div>
        </div>
    </div>
</div>
</template>

<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import EventBus from 'assets/js/eventBus';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /* 
    * Name of component
    */
    name: "PT401MemberInfoCompleteParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /* 
    * Get data from parent component
    */
    components:
    {
        Loading,
        EventBus,
        Breadcrumb
        
    },
    data() {
        return {
            isLoading: false,
            listIdErr:[],
            pt401MemberInfo:{},
            SiteConstants: SiteConstants,
            descriptionInfo:null,
            fromCart:null,
            site: "",
            syoninFlg: 0,
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt401MemberInfo = _this.ptInitData;
            _this.descriptionInfo = _this.ptInitData.descriptionInfo;
            _this.syoninFlg = _this.ptInitData.syoninFlg;
        }else{
            // eslint-disable-next-line
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT401 + _this.$UrlConstants.DO_INIT).then(function(response) {
                _this.pt401MemberInfo = response.data;
                _this.descriptionInfo = response.data.descriptionInfo;
                _this.syoninFlg = response.data.syoninFlg;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    methods: {
        buy_step1: function() {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 19}});
        },
        buy_step2: function() {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 81}});
        },
        buy_step3: function() {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 1}});
        }
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var paramData = _this.$route.query;
        if(Object.keys(paramData).length > 0){
            if(!common.isNullItem(paramData.fromCart))
                _this.fromCart = paramData.fromCart;
        }
    }
}
</script>